



































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import MobileDetect from 'mobile-detect';

import type { CompanySetting } from '@/models/companySetting';
import type { Tag } from '@/models/tag';
import type { XSubProcess } from '@/models/xsubprocess';
import { Getter } from 'vuex-class';

@Component({
    name: 'XFilteringSetting',
})
export default class FilteringSetting extends Vue {
    @Prop() private subPhases: XSubProcess[];
    @Prop() private selectedSubPhase: XSubProcess;

    @Prop() private tags: Tag[];
    @Prop() private selectedTag: Tag;
    @Prop() private companySetting: CompanySetting;
    @Prop() private canResetFilter: boolean;

    @Prop() private showOnlyMyLessons: boolean;

    @Getter('utils/currentLocale') private currentLocale: string;

    private get isDesktop() {
        const isNotDesktop = window.matchMedia('only screen and (max-width: 1300px)').matches;
        const md = new MobileDetect(window.navigator.userAgent);
        return !(md.mobile() || md.phone() || md.tablet() || isNotDesktop);
    }

    get showOnlyMyLessonsCopy() {
        return this.showOnlyMyLessons;
    }

    // noinspection JSUnusedGlobalSymbols
    set showOnlyMyLessonsCopy(value: boolean) {
        this.$emit('showOnlyMyLessonsChanged', value);
    }

    get showEmptyXSubProcesses() {
        return this.$store.getters['knowledge/showEmptyXSubProcesses'];
    }

    set showEmptyXSubProcesses(value: boolean) {
        this.$store.commit('knowledge/setShowEmptyXSubProcesses', value);
    }

    get selectedSubPhaseCopy() {
        return this.selectedSubPhase;
    }

    // noinspection JSUnusedGlobalSymbols
    set selectedSubPhaseCopy(value: XSubProcess) {
        this.$emit('SubPhaseChanged', value);
    }

    get selectedTagCopy() {
        return this.selectedTag;
    }

    // noinspection JSUnusedGlobalSymbols
    set selectedTagCopy(value: Tag) {
        this.$emit('tagChanged', value);
    }
}
